var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReddit = function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 10.233a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.737 10.15a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M17.055 2.25a.375.375 0 1 0-.533-.528.375.375 0 0 0 .533.529M14.285 13.409a9.516 9.516 0 0 1-3.284.563c-1.22 0-2.32-.21-3.284-.563",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.766 10.813a2.07 2.07 0 0 1-.476-.32 2.043 2.043 0 0 1 2.774-2.998C6.563 6.421 8.654 5.74 11 5.74c2.345 0 4.437.682 5.936 1.755a2.042 2.042 0 0 1 2.774 2.998c-.14.132-.305.233-.476.32.04.226.067.454.067.685 0 3.092-3.66 5.76-8.301 5.76s-8.301-2.668-8.301-5.76c0-.23.027-.459.067-.684Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11 5.74.629-2.805a2 2 0 0 1 2.345-1.523l2.455.492",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReddit;